import { Variant } from "../../types/types";

export function getMinLength(variant: Variant): number {
  if (!variant.price) return 1;
  const productCode = variant.displayCode;
  if (
    !!productCode &&
    (productCode.startsWith("504") || productCode.startsWith("506"))
  ) {
    const price = parseFloat(variant.price.value);
    if (price <= 4.5) {
      return 6;
    } else if (price >= 4.51 && price <= 4.99) {
      return 4;
    } else if (price >= 5.0 && price <= 7.0) {
      return 3;
    } else if (price > 7.0 && price < 16.0) {
      return 2;
    }
  }
  return 1;
}
